"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupItem = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _styled = require("./styled");

var GroupItem = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(GroupItem, _PureComponent);

  var _super = (0, _createSuper2["default"])(GroupItem);

  function GroupItem() {
    (0, _classCallCheck2["default"])(this, GroupItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GroupItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          subheading = _this$props.subheading,
          isNew = _this$props.isNew,
          isDraft = _this$props.isDraft,
          indicatorText = _this$props.indicatorText,
          onClick = _this$props.onClick,
          isSelected = _this$props.isSelected,
          color = _this$props.color;
      return /*#__PURE__*/_react["default"].createElement(_styled.GroupItemGrid, {
        id: id,
        container: true,
        justify: "space-between",
        alignItems: "center",
        wrap: "nowrap",
        onClick: onClick,
        isSelected: isSelected
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true,
        wrap: "nowrap",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        id: "".concat(id, "-avatar"),
        alt: "".concat(name, " avatar"),
        backgroundColor: color
      }, name.substring(0, 2))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_styled.GroupName, {
        variant: "subtitle1",
        isSelected: isSelected
      }, name)), !!subheading && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_styled.GroupSubHeading, {
        isSelected: isSelected,
        variant: "body2"
      }, subheading)))), !!indicatorText && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_styled.GroupItemChip, {
        variant: "outlined",
        label: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          color: "inherit",
          variant: "caption",
          disableOverflowWrap: true
        }, indicatorText),
        isNew: isNew,
        isDraft: isDraft
      })));
    }
  }]);
  return GroupItem;
}(_react.PureComponent);

exports.GroupItem = GroupItem;
GroupItem.defaultProps = {
  subheading: null,
  isNew: false,
  isDraft: false,
  isSelected: false,
  indicatorText: '',
  color: null,
  onClick: null
};
var _default = GroupItem;
exports["default"] = _default;